import { HStack, IconButton, Textarea, VStack } from '@chakra-ui/react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FaInfo } from 'react-icons/fa'

import { Field } from '@/components/ui/field'
import { Switch } from '@/components/ui/switch'
import { Tooltip } from '@/components/ui/tooltip'

import { CircleWizardFormData } from '../types'

export const DetailsStep = () => {
  const { t } = useTranslation()
  const { register, control } = useFormContext<CircleWizardFormData>()

  return (
    <VStack gap={6} w="full" align="stretch">
      <Field label={t('communities.form.description.label')}>
        <Textarea
          width="100%"
          rows={6}
          placeholder={t('communities.form.description.placeholder')}
          {...register('description')}
        />
      </Field>

      <Field
        label={
          <HStack>
            {t('communities.form.indexable.label')}
            <Tooltip
              content={t('communities.form.indexable.help')}
              showArrow={true}
              openDelay={50}
              closeDelay={100}
            >
              <IconButton
                size="sm"
                rounded="full"
                variant="ghost"
                color="gray.500"
                aria-label={t('communities.form.indexable.help')}
              >
                <FaInfo />
              </IconButton>
            </Tooltip>
          </HStack>
        }
      >
        <Controller
          name="indexable"
          control={control}
          render={({ field }) => (
            <Switch
              checked={field.value}
              onCheckedChange={(e: { checked: boolean }) => {
                field.onChange(e.checked)
              }}
            />
          )}
        />
      </Field>
    </VStack>
  )
}
